import { EmailTemplatesSidebarHeader as Header } from "./header";
import { EmailTemplatesSidebarTabs as Tabs } from "./tabs";
import { EmailTemplatesSidebarPrimaryContent as PrimaryContent } from "./primary-content";

export const EmailTemplatesSidebarContentV2 = () => {
  return (
    <div className="h-full">
      <Header className="mb-3" />
      <Tabs />
      <PrimaryContent />
    </div>
  );
};
